/**
 * Check if a pattern matches an endpoint
 * Supports wildcards (*) for single path segments and exact matches
 * Also supports "{id}" style placeholders for path parameters
 */
export function matchesPattern(pattern: string, endpoint: string): boolean {
  if (pattern === '*') {
    return true;
  }

  if (!pattern.includes('*') && !pattern.includes('{')) {
    return pattern === endpoint;
  }

  let regexPattern = pattern.replace(/[.+?^$()|[\]\\]/g, '\\$&');

  regexPattern = regexPattern.replace(/\{[^}]+\}/g, '[^/]+');

  regexPattern = regexPattern.replace(/\*/g, '[^/]*');

  const regex = new RegExp(`^${regexPattern}$`);
  return regex.test(endpoint);
}

/**
 * Test if an endpoint should be routed to the new service based on patterns
 * This is a standalone utility function for testing and external use
 */
export function shouldUseNewService(
  endpoint: string,
  method: string = 'GET',
  newServiceEndpoints: string[]
): boolean {
  return newServiceEndpoints.some((pattern) => {
    if (pattern.includes(':')) {
      const [patternMethod, patternPath] = pattern.split(':', 2);
      if (patternMethod.toUpperCase() !== method.toUpperCase()) {
        return false;
      }
      return matchesPattern(patternPath, endpoint);
    }

    return matchesPattern(pattern, endpoint);
  });
}
